// CASES
export const ACTIVE = "ACTIVE";
export const DELETING = "DELETING";

// CLIPS
export const CONVERTING = "CONVERTING";
export const COPYING = "COPYING";
export const DELETE_COMPLETE = "DELETE_COMPLETE";
export const EDITING = "EDITING";
export const EXTRACTING = "EXTRACTING";
export const FILTERING = "FILTERING";
export const GLIMPSE_COMPLETE = "GLIMPSE_COMPLETE";
export const GLIMPSE_ERROR = "GLIMPSE_ERROR";
export const GLIMPSE_QUEUED = "GLIMPSE_QUEUED";
export const GLIMPSE_RUNNING = "GLIMPSE_RUNNING";
export const NOISE_FILTER_RUNNING = "NOISE_FILTER_RUNNING";
export const NOISE_FILTERING = "NOISE_FILTERING";
export const NOISE_FILTERING_COMPLETE = "NOISE_FILTERING_COMPLETE";
export const NOISE_FILTERING_QUEUED = "NOISE_FILTERING_QUEUED";
export const NORMALIZING = "NORMALIZING";
export const NORMALIZING_FAILED = "NORMALIZING_FAILED";
export const NORMALIZING_FILTER = "NORMALIZING_FILTER";
export const PROCESSING_FAILED = "PROCESSING_FAILED";
export const REVERTING = "REVERTING";
export const SYNC_FILTER_RUNNING = "SYNC_FILTER_RUNNING";
export const SYNC_FILTERING_COMPLETE = "SYNC_FILTERING_COMPLETE";
export const SYNC_FILTERING_ERROR = "SYNC_FILTERING_ERROR";
export const SYNC_FILTERING_QUEUED = "SYNC_FILTERING_QUEUED";
export const TRIMMING = "TRIMMING";
export const UPLOADING = "UPLOADING";
export const UPLOAD_ERROR = "UPLOAD_ERROR";
export const WAITING_FOR_FILES = "WAITING_FOR_FILES";
export const STOI_QUEUED = "STOI_QUEUED";
export const STOI_RUNNING = "STOI_RUNNING";
export const STOI_COMPLETE = "STOI_COMPLETE";
export const ALIGNMENT_QUEUED = "ALIGNMENT_QUEUED";
export const ALIGNMENT_RUNNING = "ALIGNMENT_RUNNING";
export const ALIGNMENT_COMPLETE = "ALIGNMENT_COMPLETE";
export const ALIGNMENT_ERROR = "ALIGNMENT_ERROR";
export const MERGE_QUEUED = "MERGE_QUEUED";
export const MERGE_RUNNING = "MERGE_RUNNING";
export const MERGE_ERROR = "MERGE_ERROR";
export const ASI_FILTER_COMPLETE = "ASI_FILTER_COMPLETE";
export const NLMS_FILTER_COMPLETE = "NLMS_FILTER_COMPLETE";
export const ASI_FILTER_ERROR = "ASI_FILTER_ERROR";
export const NLMS_FILTER_ERROR = "NLMS_FILTER_ERROR";
export const ASI_FILTER_QUEUED = "ASI_FILTER_QUEUED";
export const ASI_FILTER_RUNNING = "ASI_FILTER_RUNNING";
export const NLMS_FILTER_QUEUED = "NLMS_FILTER_QUEUED";
export const NLMS_FILTER_RUNNING = "NLMS_FILTER_RUNNING";
export const BECOMING_SINGLE_CHANNEL = "BECOMING_SINGLE_CHANNEL";
export const STOI_ERROR = "STOI_ERROR";

// STATUS LABELS
export const STATUS_LABELS = {
  [ASI_FILTER_COMPLETE]: "ASI",
  [NLMS_FILTER_COMPLETE]: "NLMS",
  [GLIMPSE_COMPLETE]: "GLIMPSED",
};
